export var locationData = [
  { id: "wuppertal", name: "Wuppertal" },
  { id: "oberhausen", name: "Oberhausen" },
  { id: "koeln", name: "Köln" },
  { id: "kassel", name: "Kassel" },
  { id: "bremen", name: "Bremen" },
  { id: "bergisch-gladbach", name: "Bergisch Gladbach" },
  { id: "duesseldorf", name: "Düsseldorf" },
];

var INTIMISSIMI_DESC = "Durchführung von Elektroinstallationsarbeiten einschließlich Lampenmontage, Verlegung und Kabelzug für Sprachalarmierungsanlage, Brandmeldeanlage sowie Sicherheitsbeleuchtungsanlage. Anlagen wurden im Anschluss gemeinsam mit dem TÜV erfolgreich abgenommen.";
var INTIMISSIMI_SERVICES = ["Elektroinstallation", "Lampenmontage", "Sprachalarmierung", "Brandmeldeanlage", "Sicherheitsbeleuchtung"];

var INTIMISSIMI_CITY_ARKADEN_DESC = "Durchführung von Elektroinstallationsarbeiten einschließlich Lampenmontage, Verlegung und Kabelzug. Anlagen gemeinsam mit dem TÜV erfolgreich abgenommen.";
var INTIMISSIMI_CITY_ARKADEN_SERVICES = ["Elektroinstallation", "Lampenmontage", "Kabelzug", "TÜV-Abnahme"];

export var referencesByLocation = {
  wuppertal: [
    {
      id: "uni-wuppertal",
      name: "Bergische Universität Wuppertal",
      category: "Elektroinstallation",
      description: "Elektroinstallation und Lampen Montage von über 6 Flächen.",
      services: ["Elektroinstallation", "Lampenmontage"],
      image: "/images/lz30tcnm_WhatsApp_Image_2026-03-04_at_19.07.07__1_.jpeg",
      gallery: [
        "/images/lz30tcnm_WhatsApp_Image_2026-03-04_at_19.07.07__1_.jpeg",
        "/images/m1wru1sq_WhatsApp_Image_2026-03-04_at_19.07.08.jpeg",
        "/images/bjwwaxh8_WhatsApp_Image_2026-03-04_at_19.07.09__1_.jpeg",
        "/images/d1smmy9n_WhatsApp_Image_2026-03-04_at_19.07.09__2_.jpeg",
        "/images/qlx8wkqn_WhatsApp_Image_2026-03-04_at_19.07.10.jpeg"
      ]
    },
    {
      id: "rathausgalerie",
      name: "Rathaus Galerie",
      category: "Klingelanlage",
      description: "Klingelanlage InHome/Bus und Access/IP: Kabelzug der Anlage, Montage von 3 Eingängen sowie Installation von ca. 16 Zwischenstellen und Endgeräten mit eigenen Unterverteilungen pro Server- bzw. Technikraum, in denen die Technik untergebracht ist, einschließlich der Access/IP-Inbetriebnahme gemeinsam mit @InnoWerth.",
      services: ["Klingelanlage", "Kabelzug", "Montage", "Unterverteilung"],
      image: "/images/y8t3xgbh_WhatsApp_Image_2026-03-04_at_19.07.11__2_.jpeg",
      gallery: [
        "/images/y8t3xgbh_WhatsApp_Image_2026-03-04_at_19.07.11__2_.jpeg",
        "/images/dkd3nz60_WhatsApp_Image_2026-03-04_at_19.07.05__1_.jpeg",
        "/images/c3bb8wtv_WhatsApp_Image_2026-03-04_at_19.07.08__1_.jpeg",
        "/images/u56lx5p8_WhatsApp_Image_2026-03-04_at_19.07.09.jpeg",
        "/images/gwmm9oxh_WhatsApp_Image_2026-03-04_at_19.07.11__1_.jpeg"
      ]
    },
    {
      id: "rathausgalerie-sicherheit",
      name: "Rathaus Galerie Sicherheitsbeleuchtung",
      category: "Sicherheitsbeleuchtung",
      description: "Fachgerechter Kabelzug und Montage der normgerechten Sicherheitsbeleuchtung im gesamten Center, inklusive aller Treppenhäuser und der Dachflächen – zur zuverlässigen Absicherung von Flucht- und Rettungswegen.",
      services: ["Sicherheitsbeleuchtung", "Kabelzug", "Montage", "Fluchtwegsicherung"],
      image: "/images/rathaus_sicherheit_new_1.jpeg",
      gallery: [
        "/images/rathaus_sicherheit_new_1.jpeg",
        "/images/rathaus_sicherheit_new_2.jpeg",
        "/images/rathaus_sicherheit_new_3.jpeg",
        "/images/rathaus_sicherheit_new_4.jpeg",
        "/images/rathaus_sicherheit_new_5.jpeg"
      ]
    },
    {
      id: "troemmelchen",
      name: "Das Trömmelchen",
      subtitle: "Praxis für Heilpädagogik und Psychomotorik",
      category: "Elektroinstallation",
      description: "Komplette Elektroinstallation und Beleuchtungssystem in der Praxis Das Trömmelchen.",
      services: ["Elektroinstallation", "Beleuchtungssystem"],
      image: "/images/mhnfblrq_WhatsApp_Image_2026-03-04_at_19.07.00.jpeg",
      gallery: [
        "/images/mhnfblrq_WhatsApp_Image_2026-03-04_at_19.07.00.jpeg",
        "/images/rn69nbi7_WhatsApp_Image_2026-03-04_at_19.06.59.jpeg",
        "/images/r1do0k96_WhatsApp_Image_2026-03-04_at_19.07.03.jpeg",
        "/images/aba5udqb_WhatsApp_Image_2026-03-04_at_19.07.05.jpeg",
        "/images/jwccg70i_WhatsApp_Image_2026-03-04_at_19.07.26__1_.jpeg"
      ],
      website: "https://www.das-troemmelchen.de/"
    },
    {
      id: "intimissimi-city-arkaden-wuppertal",
      name: "Intimissimi City Arkaden",
      subtitle: "Wuppertal",
      category: "Elektroinstallation & Sicherheitstechnik",
      description: INTIMISSIMI_CITY_ARKADEN_DESC,
      services: INTIMISSIMI_CITY_ARKADEN_SERVICES,
      image: "/images/intimissimi_wuppertal_1.jpeg",
      gallery: [
        "/images/intimissimi_wuppertal_1.jpeg",
        "/images/intimissimi_wuppertal_4.jpeg",
        "/images/intimissimi_wuppertal_3.jpeg",
        "/images/intimissimi_wuppertal_2.jpeg"
      ]
    },
  ],
  oberhausen: [
    {
      id: "intimissimi-oberhausen",
      name: "Intimissimi",
      category: "Elektroinstallation & Sicherheitstechnik",
      description: INTIMISSIMI_DESC,
      services: INTIMISSIMI_SERVICES,
      image: "/images/zvkz4a9u_image004.jpg",
      imagePosition: "top",
      gallery: [
        "/images/zvkz4a9u_image004.jpg",
        "/images/4ck3eqkt_FBMI4847.JPG",
        "/images/knr6xwri_GOGE0002.JPG",
        "/images/rfowrkkx_image005.jpg"
      ]
    },
  ],
  koeln: [
    {
      id: "intimissimi-koeln",
      name: "Intimissimi",
      category: "Elektroinstallation & Sicherheitstechnik",
      description: INTIMISSIMI_DESC,
      services: INTIMISSIMI_SERVICES,
      image: "/images/nt8q7hr2_IMG_8607.JPG",
      gallery: [
        "/images/nt8q7hr2_IMG_8607.JPG",
        "/images/frdjrhbm_IMG_8610.JPG",
        "/images/ra16g2le_IMG_8612.JPG",
        "/images/05t8g1ob_IMG_8615.JPG",
        "/images/1gyipek5_IMG_8622.JPG"
      ]
    },
  ],
  kassel: [
    {
      id: "calzedonia-kassel",
      name: "Calzedonia",
      category: "Elektroinstallation & Sicherheitstechnik",
      description: INTIMISSIMI_DESC,
      services: INTIMISSIMI_SERVICES,
      image: "/images/e071vee5_image001.jpg",
      gallery: [
        "/images/e071vee5_image001.jpg",
        "/images/5w0hi2vc_image002.jpg",
        "/images/gviys712_image003.jpg"
      ]
    },
  ],
  bremen: [
    {
      id: "intimissimi-bremen",
      name: "Intimissimi",
      category: "Elektroinstallation & Sicherheitstechnik",
      description: INTIMISSIMI_DESC,
      services: INTIMISSIMI_SERVICES,
      image: "/images/z4fv7r1i_K800_Foto_20.08.25__13_37_31.JPG",
      gallery: [
        "/images/z4fv7r1i_K800_Foto_20.08.25__13_37_31.JPG",
        "/images/2nnhvq3s_K800_Foto_20.08.25__13_36_09.JPG",
        "/images/96lzb38r_K800_Foto_20.08.25__13_36_42.JPG",
        "/images/iz58b110_K800_Foto_20.08.25__13_36_50.JPG",
        "/images/4ds5ew2g_K800_Foto_20.08.25__13_37_06.JPG",
        "/images/bab6vi0e_K800_Foto_20.08.25__13_41_14.JPG"
      ]
    },
  ],
  "bergisch-gladbach": [
    {
      id: "intimissimi-bergisch-gladbach",
      name: "Intimissimi",
      category: "Elektroinstallation & Sicherheitstechnik",
      description: INTIMISSIMI_DESC,
      services: INTIMISSIMI_SERVICES,
      image: "/images/g14m9958_1image005.JPG",
      gallery: [
        "/images/g14m9958_1image005.JPG",
        "/images/gognnvdv_1image001.JPG",
        "/images/brsbf88o_1image003.JPG",
        "/images/gsx9jf9g_image004.JPG",
        "/images/7igesefn_image005.JPG"
      ]
    },
  ],
  duesseldorf: [
    {
      id: "euref-campus-duesseldorf",
      name: "EUREF-Campus Düsseldorf",
      subtitle: "Segelleuchten Montage",
      category: "Lampenmontage & Elektroinstallation",
      description: "Ausrichtung, Montage und Installation der Segelleuchten gemäß Ausführungsplanung.",
      services: ["Elektroinstallation", "Segelleuchten-Montage", "Ausführungsplanung", "Ausrichtung"],
      image: "/images/euref_duesseldorf_1.jpeg",
      gallery: [
        "/images/euref_duesseldorf_1.jpeg",
        "/images/euref_duesseldorf_2.jpeg",
        "/images/euref_duesseldorf_3.jpeg",
        "/images/euref_duesseldorf_4.jpeg"
      ]
    },
    {
      id: "dali-schiene-euref-duesseldorf",
      name: "EUREF-Campus Düsseldorf",
      subtitle: "DALI-Schienensystem & LiveLink-Steuerung",
      category: "Lichtsteuerung & DALI",
      description: "Die Beleuchtung wird über ein hochwertiges DALI-Schienensystem in U-Form inszeniert und schafft in Küche sowie Lounge ein modernes, harmonisches Lichtbild. Dank zweier voneinander unabhängiger LiveLink-Steuerungen lassen sich beide Bereiche flexibel, komfortabel und präzise dimmen sowie individuell an jede Nutzungssituation anpassen.",
      services: ["DALI-Schienensystem", "LiveLink-Steuerung", "Lichtplanung", "Dimmsteuerung"],
      image: "/images/dali_duesseldorf_2.jpeg",
      gallery: [
        "/images/dali_duesseldorf_2.jpeg",
        "/images/dali_duesseldorf_1.jpeg",
        "/images/dali_duesseldorf_3.jpeg",
        "/images/dali_duesseldorf_4.jpeg",
        "/images/dali_schiene_neu.jpeg"
      ]
    },
    {
      id: "dali-pendelleuchten-euref-duesseldorf",
      name: "EUREF-Campus Düsseldorf",
      subtitle: "DALI-Pendelleuchten in Reihe",
      category: "Pendelleuchten & DALI-Integration",
      description: "Die DALI-Pendelleuchten wurden in Reihe montiert, fachgerecht angeschlossen und in das LiveLink-DALI-System integriert, wodurch eine komfortable und stufenlose Dimmung der Beleuchtung möglich ist.",
      services: ["DALI-Pendelleuchten", "Reihenmontage", "LiveLink-Integration", "Stufenlose Dimmung"],
      image: "/images/dali_pendel_duesseldorf_1.jpeg",
      gallery: [
        "/images/dali_pendel_duesseldorf_1.jpeg",
        "/images/dali_pendel_duesseldorf_2.jpeg",
        "/images/dali_pendel_duesseldorf_3.jpeg",
        "/images/dali_pendel_neu.jpeg"
      ]
    },
  ],
};
